export default __webpack_public_path__ + "static/media/before-trip-2.df680fa0.svg";